<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">挖矿设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>分红概况</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-date-picker type="date" placeholder="选择分红日期" v-model="shareTime"></el-date-picker>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
      <el-table
        :data="shareSummary"
      >
        <el-table-column
          prop="coinType"
          label="币种">
        </el-table-column>
        <el-table-column
          label="分红时间">
          <template slot-scope="scope">
            {{ scope.row.shareTime | moment('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="validBkkTotal"
          label="有效BKK">
        </el-table-column>
        <el-table-column
          prop="shareFeeTotal"
          label="分红手续费">
        </el-table-column>
        <el-table-column
          prop="tradeTotal"
          label="交易总额">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MiningSummary',
  data() {
    return {
      shareTime: new Date()
    };
  },
  computed: {
    ...mapGetters('miningSummary', ['shareSummary'])
  },
  methods: {
    ...mapActions('miningSummary', ['getShareSummary']),
    handleSearch() {
      this.getShareSummary(this.shareTime);
    }
  },
  created() {
    this.getShareSummary(this.shareTime);
  }
};
</script>

<style lang="less" scoped>
</style>
